import { routes } from '~/shared/constants/routes';
import { createUrlWithSearchParams, getSearchParamsValues } from '~/shared/lib/searchParams';

const payinTradersSearchParamNames = {
    mode: 'mode',
    traderName: 'traderName',
} as const;

interface PayinTradersSearchParams {
    traderName?: string;
}

export const getPayinTradersSearchParams = (searchParams: URLSearchParams): PayinTradersSearchParams => {
    return getSearchParamsValues<PayinTradersSearchParams>(searchParams, {
        traderName: payinTradersSearchParamNames.traderName,
    });
};

export const createPayinTradersUrl = ({ traderName }: PayinTradersSearchParams = {}) => {
    return createUrlWithSearchParams(
        routes.traders,
        {
            mode: 'payin',
            traderName,
        },
        payinTradersSearchParamNames,
    );
};
